import { render, staticRenderFns } from "./RegisterTermsModal.vue?vue&type=template&id=2a795548&"
import script from "./RegisterTermsModal.vue?vue&type=script&lang=js&"
export * from "./RegisterTermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports